import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialTeamDecisionState } from '@/redux/initialState/teamDecision'
import { TeamStrategyProposalItem } from '@/redux/types/teamDecision'

const teamDecisionSlice = createSlice({
  name: 'teamDecision',
  initialState: initialTeamDecisionState,
  reducers: {
    setProposals(
      state,
      action: PayloadAction<{
        proposals: TeamStrategyProposalItem[]
        voteCounts?: Record<number, number>
        votingClosed?: boolean
        winningProposalId?: number | null
        winningStrategyText?: string | null
        myVoteProposalId?: number | null
      }>
    ) {
      state.proposals = action.payload.proposals
      if (action.payload.voteCounts !== undefined) {
        state.voteCounts = action.payload.voteCounts
      }
      if (action.payload.votingClosed !== undefined) {
        state.votingClosed = action.payload.votingClosed
      }
      if (action.payload.winningProposalId !== undefined) {
        state.winningProposalId = action.payload.winningProposalId
      }
      if (action.payload.winningStrategyText !== undefined) {
        state.winningStrategyText = action.payload.winningStrategyText
      }
      if (action.payload.myVoteProposalId !== undefined) {
        state.myVoteProposalId = action.payload.myVoteProposalId
      }
    },
    addProposal(state, action: PayloadAction<{ proposal: TeamStrategyProposalItem }>) {
      const existingIndex = state.proposals.findIndex(
        (p) => p.id === action.payload.proposal.id
      )
      if (existingIndex === -1) {
        state.proposals.unshift(action.payload.proposal)
      } else {
        state.proposals[existingIndex] = action.payload.proposal
      }
    },
    updateProposal(
      state,
      action: PayloadAction<{ proposal: TeamStrategyProposalItem }>
    ) {
      const idx = state.proposals.findIndex(
        (p) => p.id === action.payload.proposal.id
      )
      if (idx !== -1) {
        state.proposals[idx] = action.payload.proposal
      }
    },
    setVoteCast(
      state,
      action: PayloadAction<{
        proposalId: number
        voterId?: number
        voterEmail?: string
        voteCounts: Record<number, number>
        myVoteProposalId?: number | null
      }>
    ) {
      state.voteCounts = action.payload.voteCounts
      if (action.payload.myVoteProposalId !== undefined) {
        state.myVoteProposalId = action.payload.myVoteProposalId
      }
    },
    setVotingClosed(
      state,
      action: PayloadAction<{
        winningProposalId?: number | null
        winningStrategyText?: string | null
        voteCounts?: Record<number, number>
      }>
    ) {
      state.votingClosed = true
      if (action.payload.winningProposalId !== undefined) {
        state.winningProposalId = action.payload.winningProposalId
      }
      if (action.payload.winningStrategyText !== undefined) {
        state.winningStrategyText = action.payload.winningStrategyText
      }
      if (action.payload.voteCounts !== undefined) {
        state.voteCounts = action.payload.voteCounts
      }
    },
    clearTeamDecisionState(state) {
      state.proposals = []
      state.voteCounts = {}
      state.myVoteProposalId = null
      state.votingClosed = false
      state.winningStrategyText = null
      state.winningProposalId = null
    },
  },
})

export const {
  setProposals,
  addProposal,
  updateProposal,
  setVoteCast,
  setVotingClosed,
  clearTeamDecisionState,
} = teamDecisionSlice.actions

export default teamDecisionSlice.reducer
